export default function GenericCard({ name, text, subtext }) {
    return (
        <div className="bg-fr-light border border-fr-muted rounded-xl shadow-sm p-4 flex flex-col justify-center items-start w-full transition hover:shadow-md hover:border-fr-primary">
            <p className="text-xs text-fr-muted font-medium mb-1">{name}</p>
            <p className="text-xl font-semibold text-fr-dark">{text}</p>
            {subtext ? (
                <p className="text-[11px] text-fr-muted mt-1">{subtext}</p>
            ) : (
                <span className="invisible text-[11px] mt-1">placeholder</span>
            )}
        </div>
    );
}
